import { Pipe, PipeTransform } from '@angular/core';

import { PipesHelperInterface } from '@core/interfaces';

@Pipe({
  name: 'selectSearch',
  standalone: false
})
export class SelectSearchPipe implements PipeTransform {

  transform(items: PipesHelperInterface.ISelectCategoryPipeData[], search = ''): PipesHelperInterface.ISelectCategoryPipeData[] {
    if (!search.trim()) {
      return items;
    }

    return items.filter(item => {
      return item.name.toLowerCase().includes(search.toLowerCase()) || item.id.toString().toLowerCase().includes(search.toLowerCase());
    });
  }

}
